export default "__VITE_ASSET__CPvShiMS__"